<template>
    <div class="ForgotPasswordPage">
        <SiteHeader/>

        <Container>
            <div v-if="!submitSuccess">
                <h1>Forgot Password?</h1>
                <Card>
                    <form @submit.prevent="handleSubmit">
                        <p>Enter your email address below and we will send you a link to reset your password.</p>

                        <FormInput
                            v-model="$v.email.$model"
                            lazy
                            label="Email Address"
                            :errors="$v.email.$error ? [
                                !$v.email.required && 'Email is required',
                                !$v.email.email && 'Has to be a valid email address',
                            ] : null"
                        />

                        <Button class="primary block" type="submit" :disabled="submitPending">Reset Password</Button>
                    </form>
                </Card>
            </div>
            <div v-else>
                <h1>Password Reset Sent</h1>
                <Card>
                    <p>Please check your email for instructions on how to reset your password.</p>
                </Card>
            </div>
        </Container>

        <SiteFooter/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import Card from '@/components/Card';
import * as api from '@/api';
import { required, email } from 'vuelidate/lib/validators';

export default {
    name: 'ForgotPasswordPage',

    data: () => ({
        email: null,
        submitPending: false,
        submitSuccess: false,
    }),

    components: {
        SiteHeader,
        SiteFooter,
        Card,
    },

    validations: {
        email: { required, email },
    },

    methods: {
        async handleSubmit() {
            if (this.submitPending) return;

            this.$v.$touch();
            if (this.$v.$invalid) return;


            this.submitPending = true;
            const res = await api.requestPasswordReset(this.email);
            this.submitPending = false;

            if (res.error) {
                return this.$awn.alert('Failed to send password reset token');
            }

            this.submitSuccess = true;
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ForgotPasswordPage {
    display: flex;
    flex-wrap: wrap;
    min-height: 100vh;

    .Container {
        margin-top: 30px;
        margin-bottom: 80px;
        text-align: center;

        h1 {
            @extend %display-subtitle;
            margin-bottom: 30px;
        }

        p {
            @extend %display-description;
            margin: 0 auto 30px;
        }
    }

    .Card {
        max-width: 600px;
        margin: 0 auto;
    }

    .SiteFooter {
        align-self: flex-end;
    }
}
</style>
